"use client";

import React from "react";

//type
import type { InputGroupProps } from "@/types";

//Style
import * as S from "./styles";

const InputIconGroup: React.FC<
  Omit<InputGroupProps, "onChange"> & {
    onChange: (
      e:
        | React.ChangeEvent<HTMLInputElement>
        | { target: { name: string; value: any } },
    ) => void;
  }
> = ({ className, icon, placeholder, name, value, onChange }) => {
  return (
    <S.InputGroup className={className}>
      <S.IconComponent name={icon} />
      <S.InputComponent
        name={name}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
      />
    </S.InputGroup>
  );
};

export default InputIconGroup;
